// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2oFBO","subheader":"ReorderModal_subheader__i4YZr","listWrap":"ReorderModal_listWrap__CzWXX"};